export default __webpack_public_path__ + "static/isff-white-f7b2452d7bc37d63a41805f5406b7783.png";